import { render, staticRenderFns } from "./beneficiarylist.vue?vue&type=template&id=43f141d8"
import script from "./beneficiarylist.vue?vue&type=script&lang=js"
export * from "./beneficiarylist.vue?vue&type=script&lang=js"
import style0 from "./beneficiarylist.vue?vue&type=style&index=0&id=43f141d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports